import { fetchJson } from "../../../../utils";
import { reportError } from "../../basket-v2/errorReporting";
import { BasketResponse, ApiResponseWithData } from "./models";

type UpgradeBasketOptions = {
  orderId: string;
  originalPriceZoneId: string;
  upgradePriceZoneId: string;
};

export async function removeUpgradeFromBasket({ orderId, originalPriceZoneId, upgradePriceZoneId }: UpgradeBasketOptions) {
  const { success, errors, data } = await fetchJson<ApiResponseWithData<BasketResponse>>(
    `/api/v2/basket/remove-upgrade/${orderId}/${originalPriceZoneId}/${upgradePriceZoneId}`,
    {
      method: "POST",
    }
  );

  if (success) {
    return data;
  } else {
    reportError("ft", errors.map((e) => e.message).join(", "));
    return false;
  }
}
